/** The key one statement's prediction progress is kept under. */
export const predictionKeyOf = (reportId: string, reportType: string) => `${reportId}-${reportType}`
